import React from "react";
import NewChat from "components/NewChat/NewChat";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { useSelector } from "@/types/store";
import { getIsCreatingFocusedDataset } from "../App/reducer";
const Loading = () => {
    return (React.createElement("div", { style: {
            height: "calc(100vh - 60px)",
            margin: "40vh auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        } },
        React.createElement(LoadingIndicator, null),
        React.createElement("div", null, "Saving What's Changed focus, please do not navigate away from this page...")));
};
const NewChatContainer = () => {
    const isCreatingFocusedDataset = useSelector(getIsCreatingFocusedDataset);
    return isCreatingFocusedDataset ? React.createElement(Loading, null) : React.createElement(NewChat, null);
};
export default NewChatContainer;
